<p-sidebar [(visible)]="visible" position="right" [modal]="false" (onHide)="handleHide()"
           (onShow)="bindScrollElement()" #bar>
    <ng-template pTemplate="header">
        <span class="title">Powiadomienia</span>
        <span>
            <i class="fas fa-refresh ldn-button ldn-button--link" (click)="load()"
               title="Odśwież"></i>
            <div ldn-dropdown [ldnDropdownCloseOnInnerClick]="true">
            <span class="ldn-button ldn-button--link ldn-button--sm"
                  ldn-dropdown-toggle
                  [ldnDropdownToggleArrow]="true">
                <i class="fas fa-filter"></i>
            </span>
                <div ldn-dropdown-menu>
                    <div (mousedown)="filter(null)"
                            class="ldn-button ldn-button--link ldn-button--sm"
                            [ngClass]="{'selected': selectedFilter() === null}">
                        Wszystkie
                    </div>
                    <div (mousedown)="filter(action)"
                            *ngFor="let action of filterOptions"
                            class="ldn-button ldn-button--link ldn-button--sm"
                            [ngClass]="{'selected': selectedFilter() === action[0]}">
                        {{ action[1] }}
                    </div>
                </div>
            </div>
        </span>
    </ng-template>
    <!--    <ng-template pTemplate="content">Body Content</ng-template>-->
    <div *ngIf="notifications().length === 0" class="info">Brak powiadomiń
    <div *ngIf="selectedFilter() !== null">{{GroupActionPipe.enumDescriptionMap.get(selectedFilter())}}</div>
    </div>
    <ul>
        <li *ngFor="let notification of notifications()" class="notification"
            [ngClass]="{'notification-error': notification.worstType === messageType.Error, 'notification-warning': notification.worstType === messageType.Warning,
                    'notification-info': notification.worstType === messageType.Info, 'notification-success': notification.worstType === messageType.Success,
                    'not-read': !notification.read}">
            <div
                class="header">{{ notification.id }} {{ notification.date | ldnDateTimeSeconds }} {{ notification.messages.length }}
                /{{ notification.expectedResults }}
            </div>
            <div class="content"><span [innerHtml]="notification.description"></span>
                <button *ngIf="notification.expectedResults > 1 && notification.messages.length > 0"
                        (click)="notification.showMessages = !notification.showMessages"
                        class="ldn-button ldn-button--sm ldn-button--link">Więcej...
                </button>
            </div>
            <ul *ngIf="notification.showMessages">
                <li *ngFor="let message of notification.messages" class="message"
                    [ngClass]="{'message-error': message.type === messageType.Error, 'message-warning': message.type === messageType.Warning,
                    'message-info': message.type === messageType.Info, 'message-success': message.type === messageType.Success,
                    'not-read': !message.read}">
                    <div class="header">{{ message.addedDate | ldnDateTimeSeconds }}</div>
                    <div class="content" [innerHtml]="message.content"></div>
                </li>
            </ul>
        </li>
    </ul>
    <!--    <ng-template pTemplate="footer">-->
    <!--        <button (click)="loadMore()" class="ldn-button ldn-button&#45;&#45;sm ldn-button&#45;&#45;link">Więcej...</button>-->
    <!--    </ng-template>-->
</p-sidebar>